import { Channel } from '@/types';

type Field = 'custom.slug' | 'custom.uniqueSlug';

const themes: Record<Channel['theme'], Field> = {
  brand: 'custom.slug',
  'nightcap-venues': 'custom.uniqueSlug',
};

export function getVenueParamField(channel: Channel): Field {
  return themes[channel.theme || 'brand'];
}
